import { css } from 'astroturf';
import React from 'react';
import Link from '../link';

import Support from '../../../assets/images/support.svg';

const styles = css`
  .additional {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 2rem;
    font-size: 1.125rem;
    margin-top: 4rem;
    padding-top: 2rem;
    text-align: left;
    border-top: 1px solid #0a153044;

    & h3 {
      line-height: 1;
      font-size: 1.5rem;
      font-weight: 900;
      color: #2c82ad;
    }
    & p {
      margin: 0.5rem 0 1.5rem;
    }

    & svg {
      width: 100%;
      height: 100%;
    }

    & > div:first-child {
      display: none;
      @media (min-width: 40rem) {
        display: block;
      }
    }
  }

  .button {
    pointer-events: all;
    margin: 0;
    font-size: calc(14px + 0.5vw);
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
    background: #0a1530;
    border: 0px solid #0a1530;
    padding: 0.33em 1rem;
    border-radius: 8px;
    text-align: center;
    display: inline-block;
    text-decoration: none;
    line-height: 26px;
    transition: all 0.25s ease-in-out;
    overflow: hidden;
    white-space: nowrap;
    margin-left: -4px;
    text-decoration: none;

    & span {
      position: relative;
      z-index: 1;
    }

    &::before {
      content: ' ';
      display: block;
      background: linear-gradient(135deg, #4ca2cd, #67b26f);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
      opacity: 0;
      transition: opacity 0.25s ease-in-out;
      border-radius: 8px;
    }

    @media (min-width: 600px) {
      font-size: 16px;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 2rem;
      padding-right: 2rem;
      line-height: 40px;
      height: 40px;
    }

    &:hocus {
      text-decoration: none;
      &::before {
        opacity: 1;
      }
    }

    & svg {
      vertical-align: middle;
    }
  }
`;

const DocSupport = (props) => (
  <div className={styles.additional}>
    <div>
      <Support />
    </div>
    <div>
      <h3>Have a question about Polypane?</h3>
      <p>Reach out via (real human) chat, Slack or our contact form:</p>
      <Link to="/support/" className={styles.button}>
        <span>Contact Support</span>
      </Link>
    </div>
  </div>
);

export default DocSupport;
